import React from 'react';
import { AnimatePresence } from 'framer-motion';
import {
  CONTAINER_HEIGHT,
  FixedContainer,
  GAP,
  ImageWrapper, LightOverlay,
  Overlay,
  RowContainer,
  TrashIcon
} from "./imageUploader.styles";
import { IMedia } from "models/wall";

interface ImageListProps {
  images: IMedia[];
  onClick?: (uuid: string) => void;
  hideDelete?: boolean;
}

function chunkImages(images: IMedia[]): IMedia[][] {
  const n = images.length;
  const rows: IMedia[][] = [];
  let i = 0;
  while (i < n) {
    const remaining = n - i;
    if (remaining === 4 && rows.length === 0) {
      rows.push(images.slice(i, i + 2));
      i += 2;
      rows.push(images.slice(i, i + 2));
      i += 2;
    } else if (remaining === 4) {
      rows.push(images.slice(i, i + 4));
      i += 4;
    } else if (remaining === 1) {
      if (rows.length > 0) {
        const lastRow = rows[rows.length - 1];
        if (lastRow.length === 2 || lastRow.length === 3) {
          lastRow.push(images[i]);
          i++;
        } else {
          rows.push(images.slice(i, i + 1));
          i++;
        }
      } else {
        rows.push(images.slice(i, i + 1));
        i++;
      }
    } else if (remaining === 2 || remaining === 3) {
      rows.push(images.slice(i, i + remaining));
      i += remaining;
    } else {
      rows.push(images.slice(i, i + 3));
      i += 3;
    }
  }
  return rows;
}

const ImageList: React.FC<ImageListProps> = ({ images, onClick, hideDelete }) => {
  const rows = chunkImages(images);
  const rowCount = rows.length;
  const totalVerticalGap = (rowCount - 1) * GAP;
  const rowHeight = (CONTAINER_HEIGHT - totalVerticalGap) / rowCount;

  return (
    <AnimatePresence>
      <FixedContainer
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        {rows.map((rowImages, rowIndex) => (
          <RowContainer
            key={rowIndex}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: rowIndex * 0.1 }}
          >
            {rowImages.map((image, imgIndex) => (
              <ImageWrapper key={image.uuid}>
                <img src={image.file as string} alt={`Row ${rowIndex} - Image ${imgIndex}`} />
                {onClick && hideDelete && (
                  <LightOverlay onClick={(e) => {e.stopPropagation(); onClick(image.uuid)}} />
                )}
                {onClick && !hideDelete && (
                  <Overlay
                    onClick={(e) => {e.stopPropagation(); onClick(image.uuid)}}
                  >
                    <TrashIcon viewBox="0 0 24 24">
                      <polyline points="3 6 5 6 21 6" />
                      <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                      <path d="M10 11v6" />
                      <path d="M14 11v6" />
                      <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
                    </TrashIcon>
                  </Overlay>
                )}
              </ImageWrapper>
            ))}
          </RowContainer>
        ))}
      </FixedContainer>
    </AnimatePresence>
  );
};

export default ImageList;
